import { GridRowSelectionModel } from '@mui/x-data-grid';
import { GridSortItem } from '@mui/x-data-grid/models/gridSortModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IObject } from '../interfaces/IObject';

interface LocationState {
  selectedRow: GridRowSelectionModel;
  pageNumber: number;
  filters: IObject;
  sorting: GridSortItem[];
  editDetails: any;
  openCreateLocation: boolean;
}

const initialState: LocationState = {
  selectedRow: { type: 'include', ids: new Set() },
  pageNumber: 0,
  filters: { name: null },
  sorting: [],
  editDetails: null,
  openCreateLocation: false,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setSelectedRow: (state, action: PayloadAction<GridRowSelectionModel>) => {
      state.selectedRow = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setFilters: (state, action: PayloadAction<IObject>) => {
      state.filters = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sorting = action.payload;
    },
    setEditDetails: (state, action: PayloadAction<any | null>) => {
      state.editDetails = action.payload;
    },
    setOpenCreateLocation: (state, action: PayloadAction<boolean>) => {
      state.openCreateLocation = action.payload;
    },
  },
});

export const {
  setSelectedRow,
  setPageNumber,
  setFilters,
  setSorting,
  setEditDetails,
  setOpenCreateLocation,
} = locationSlice.actions;

export default locationSlice.reducer;
